"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Alert = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.orange,
  d: "M16,26 C21.5228475,26 26,21.5228475 26,16 C26,10.4771525 21.5228475,6 16,6 C10.4771525,6 6,10.4771525 6,16 C6,21.5228475 10.4771525,26 16,26 Z M16.1111111,19.7777778 C16.7247608,19.7777778 17.2222222,20.2752392 17.2222222,20.8888889 C17.2222222,21.5025386 16.7247608,22 16.1111111,22 C15.4974614,22 15,21.5025386 15,20.8888889 C15,20.2752392 15.4974614,19.7777778 16.1111111,19.7777778 Z M16.9907408,10.6666667 L16.9907408,18.6666667 L15.2314814,18.6666667 L15.2314814,18.6666667 L15.2314814,10.6666667 L16.9907408,10.6666667 L16.9907408,10.6666667 Z"
}));

var _default = Alert;
exports.default = _default;